module.exports = "<header>\n    <h1 class=\"header--brand\">{{_.i18n('Encryptic')}}</h1>\n</header>\n<div class=\"container-fluid container--white\" id=\"welcome--content\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/setup/template.html
// module id = 731
// module chunks = 0